import { render, staticRenderFns } from "./tradeList.vue?vue&type=template&id=4034988e"
import script from "./tradeList.vue?vue&type=script&lang=js"
export * from "./tradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports